import { useRootStore } from './useRootStore';

export function useUTMStore() {
  const { utmStore } = useRootStore();
  return utmStore;
}
